import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import './styles.scss'

const SupportButton: React.FC = () => {
  return (
    <div className="support-button">
      <div className="support-button__container">
        <a className="support-button__button" href="mailto:signalssupport@destini.co">
          <FontAwesomeIcon icon={faQuestionCircle} />
          <span className="support-button__text">Support</span>
        </a>
      </div>
    </div>
  )
}

export default SupportButton;